/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./index.css";
import {NavLink} from "react-router-dom";

const ProductsList = () => {

  const path = window.location.pathname;
  return (
    <div className="product-list">
      <div id="chocolates">
        <NavLink
          to="/chocolates#chocolates"
          className={path.includes('productos') || path.includes('chocolates') ? 'list-highlight' : ''}
        >
          chocolates
        </NavLink>
      </div>
      <div id="alfajores">
        <NavLink
          to="/alfajores#alfajores"
          className={path.includes('alfajores') ? 'list-highlight' : ''}
        >
          alfajores
        </NavLink>
      </div>
      <div id="confituras">
        <NavLink
          to="/confituras#confituras"
          className={path.includes('confituras') ? 'list-highlight' : ''}
        >
          frutos secos bañados
        </NavLink>
      </div>
      {/*<div id="submarinos">
        <a
          href="submarinos#submarinos"
          className={path.includes('submarinos') ? 'list-highlight' : ''}
        >
          submarinos
        </a>
      </div>*/}
      {/*<div id="tabletas">
        <a
          href="tabletas#tabletas"
          className={path.includes('tabletas') ? 'list-highlight' : ''}
        >
          tabletas
        </a>
      </div>*/}
    </div>
  );
};

export default ProductsList;
